import React from 'react';

type CalendarMode = 'day' | 'week' | 'month';

interface CalendarModeToggleProps {
  mode: CalendarMode;
  onChange: (mode: CalendarMode) => void;
}

export const CalendarModeToggle: React.FC<CalendarModeToggleProps> = ({ mode, onChange }) => {
  const modes: Array<{ value: CalendarMode; label: string }> = [
    { value: 'day', label: 'Day' },
    { value: 'week', label: 'Week' },
    { value: 'month', label: 'Month' },
  ];

  return (
    <div role="tablist" className="inline-flex rounded-lg border border-gray-300 bg-gray-50 p-1">
      {modes.map((item) => (
        <button
          key={item.value}
          role="tab"
          aria-selected={mode === item.value}
          aria-pressed={mode === item.value}
          onClick={() => onChange(item.value)}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${
            mode === item.value
              ? 'bg-white text-purple-700 shadow-sm'
              : 'text-gray-700 hover:text-gray-900'
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};
